import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import { useGroupFilters } from '@app/group/hooks/use-group-filters';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetGroupOrganizations } from '@shared/api/hooks/group/organizations';
import { GroupOrganizationsListSortItem } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';
import GroupPage from '../components/group-page';
import GroupOrganizationsTable from '../components/tables/group-organizations-table';

export default function GroupOrganizationsPage() {
  const { page, perPage, sort } = useDataTableQueryState();
  const [name] = useQueryState('name', parseAsString);
  const [{ periods }] = useGroupFilters();

  const data = useGetGroupOrganizations({
    page,
    page_size: perPage,
    sort: formatMultipleSortingForEndpoint(
      sort ?? []
    ) as GroupOrganizationsListSortItem[],
    search: name || undefined,
  });

  const count = data.data?.count ?? 0;
  const pageCount = Math.ceil(count / (perPage || 10));

  if (data.isError) throw new Error('Failed to load group organisations');

  return (
    <GroupPage pageKey="organizations">
      <GroupOrganizationsTable
        {...data}
        pageCount={pageCount}
        periods={periods}
      />
    </GroupPage>
  );
}
